import { Sale, SaleRow } from "@/models/base";
import { IExtraFields, sortCompareExtraFields } from "../models/extra-fields";

export enum SortRowsProp{
	Qty = "qty",
	Supplier = "supplier",
	Brand = "brand",
	ProductSku = "sku",
	ProductDescription = "description"
}

function sortSaleRows(sale:Sale, sortFunc:(a:SaleRow, b:SaleRow)=>number | null){
	let fostplusTotalRow = sale.getFostplusTotalRow();
	let rows = sale.Rows.sort((a,b)=>{
		if (a == fostplusTotalRow) {
			return -1;
		}else if (b == fostplusTotalRow) {
			return 1;
		}
		let res = sortFunc(a,b);
		if (res !== null) {
			return res;
		}
		if (a.Product && a.Product.MainSupplier) {
			return 1;
		}
		return -1;
	});
	sale.Rows = rows;
}

// eslint-disable-next-line max-lines-per-function
export function sortSaleRowsByProp(sale:Sale, prop:SortRowsProp){
	sortSaleRows(sale, (a,b)=>{
		if (prop == SortRowsProp.Qty) {
			return b.Amount - a.Amount;
		}
		if (prop == SortRowsProp.ProductSku){
			return a.ProductSku.localeCompare(b.ProductSku);
		}
		if (prop == SortRowsProp.ProductDescription){
			return a.ProductDescription.localeCompare(b.ProductDescription);
		}
		if (a.Product && a.Product.MainSupplier && b.Product && b.Product.MainSupplier) {
			if (prop == SortRowsProp.Supplier) {
				return a.Product.MainSupplier.ContactID - b.Product.MainSupplier.ContactID;
			}
			if (prop == SortRowsProp.Brand){
				return a.Product.MainSupplier.Brand.localeCompare(b.Product.MainSupplier.Brand);
			}
		}
		return null;
	});
}

export function sortSaleRowsByExtraField(sale:Sale, extraField:string) {
	sortSaleRows(sale, (a,b)=>{
		return sortCompareExtraFields(a.ExtraFields, b.ExtraFields, extraField as keyof(IExtraFields));
	});
}

export function sortSaleRowsByProductExtraField(sale:Sale, extraField:string) {
	sortSaleRows(sale, (a,b)=>{
		let aFields = a.Product ? a.Product.ExtraFields : null;
		let bFields = b.Product ? b.Product.ExtraFields : null;
		return sortCompareExtraFields(aFields, bFields, extraField as keyof(IExtraFields));
	});
}
